import { Component } from 'react';
import { connect } from 'react-redux';
import * as LliamUtilities from '@locuslabs/lliam-utilities';
import PropTypes from 'prop-types';
import * as VmsState from '../../backend/index-vms-state';
import { PublishView } from '../../components';

const { Routing } = VmsState;

// eslint-disable-next-line
class PublishContainer extends Component {
    static propTypes = {
        animationOptions: PropTypes.object.isRequired,
        banner: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
        hasAssetsWritePermission: PropTypes.bool.isRequired,
        lastStopDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]).isRequired,
        publishPending: PropTypes.bool.isRequired,
        status: PropTypes.object.isRequired,
        venueId: PropTypes.string.isRequired,
    };

    publishVenue = () => {
        const { dispatch, venueId } = this.props;
        dispatch(VmsState.PublishStatusReducer.Thunks.publishVenue(venueId));
    };

    render = () => {
        const { animationOptions, banner, lastStopDate, publishPending, status, venueId, hasAssetsWritePermission } =
            this.props;
        return (
            <PublishView
                animationOptions={animationOptions}
                banner={banner}
                hasAssetsWritePermission={hasAssetsWritePermission}
                publishPending={publishPending}
                publishVenue={this.publishVenue}
                startDate={status.startDate}
                status={status.executionStatus}
                stopDate={lastStopDate}
                venueId={venueId}
            />
        );
    };
}

const mapStateToProps = state => {
    const venueId = Routing.Selectors.getLocationVenueId(state);
    const status = VmsState.PublishStatusReducer.Selectors.getStatus(venueId, state); // Defaults status to '' and last publish date to NOW!
    const banner = VmsState.PublishStatusReducer.Selectors.getStatusBanner(state);
    const animationOptions = VmsState.PublishStatusReducer.Selectors.getStatusAnimation(state);
    const lastStopDate = VmsState.PublishStatusReducer.Selectors.getLastSuccessDate(state);
    const publishPending = VmsState.PublishStatusReducer.Selectors.isPublishPending(venueId, state);
    const hasAssetsWritePermission = VmsState.SessionReducer.Selectors.hasWritePermissionToResource(
        venueId,
        LliamUtilities.CONSTANTS.ASSETS,
        state,
    );

    return {
        animationOptions,
        banner,
        hasAssetsWritePermission,
        lastStopDate,
        publishPending,
        status,
        venueId,
    };
};

export default connect(mapStateToProps)(PublishContainer);
